import { Stack } from './Stack';
import type { StackProps } from './Stack';
import type { SpacingToken } from '@/theme/tokens';

type InlineProps = Omit<StackProps, 'gap' | 'ref'> & {
  gap?: SpacingToken;
  wrap?: 'nowrap' | 'wrap';
};

export const Inline = ({ gap = 'sm', sx, wrap = 'wrap', ...rest }: InlineProps): JSX.Element => (
  <Stack
    direction="row"
    wrap={wrap}
    align="center"
    gap={gap}
    sx={
      sx
        ? ([{ width: '100%', minWidth: 0 }, ...(Array.isArray(sx) ? sx : [sx])] as StackProps['sx'])
        : { width: '100%', minWidth: 0 }
    }
    {...rest}
  />
);
